<template>
  <div class="c-content">
    <slot name="noscroll"></slot>
    <div class="scroller"
         ref="scroller"
         v-alloytouch="{options: options,methods:{touchStart:touchStart, animationEnd:onAnimationEnd,initAlloyTouch: initAlloyTouch}}">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './index';
</style>
<script>
import '../../directive/alloytouch'
export default {
  name: 'c-content',
  data () {
    return {
      options: {
        touch: '', // 反馈触摸的dom
        target: '', // 运动的对象
        vertical: true, // 不必需，默认是true代表监听竖直方向touch
        property: 'translateY',  // 被滚动的属性
        sensitivity: 1, // 不必需,触摸区域的灵敏度，默认值为1，可以为负数
        factor: 0.6, // 不必需,默认值是1代表touch区域的1px的对应target.y的1
        step: 45,
        maxSpeed: 2
      },
      min: 1000,
      handleAlloyTouch: null
    }
  },
  components: {},
  created () { },
  mounted () {
  },
  beforeDestroy () { },
  methods: {
    initAlloyTouch (handle) {
      this.handleAlloyTouch = handle
    },
    onAnimationEnd () {
    },
    touchStart () {
      let scroller = this.$refs.scroller
      if (scroller.offsetHeight >= scroller.parentNode.offsetHeight) {
        this.handleAlloyTouch.min = -1 * parseInt(scroller.offsetHeight) + scroller.parentNode.offsetHeight
      } else {
        this.handleAlloyTouch.min = 0
      }
    }
  },
  computed: {},
  events: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?e813f2b0